import React from 'react';
import { Mail, MapPin, Phone, Linkedin, Twitter, Globe } from 'lucide-react';
import { company, regions } from '../mock/data';
import { useI18n } from '../context/I18nContext';

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer id="contact" className="bg-[#061a34] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-md bg-[#f7a11a] flex items-center justify-center">
                <span className="text-slate-900 font-black text-xl">U</span>
              </div>
              <div className="leading-tight">
                <div className="font-bold text-lg">UDAAN</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/60">Worldwide Export</div>
              </div>
            </div>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">{t('footer.tagline')}</p>
            <div className="mt-6 flex gap-3">
              {[Linkedin, Twitter, Globe].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#f7a11a] hover:border-[#f7a11a] hover:text-slate-900 transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs tracking-[0.3em] uppercase text-[#f7a11a] font-semibold mb-4">{t('footer.quickLinks')}</div>
            <ul className="space-y-3 text-white/70">
              {['products','about','why','sectors','certifications','contact'].map((k) => (
                <li key={k}><a href={`#${k === 'why' ? 'why' : k}`} className="hover:text-[#f7a11a] transition-colors">{t(`nav.${k}`)}</a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs tracking-[0.3em] uppercase text-[#f7a11a] font-semibold mb-4">{t('footer.getInTouch')}</div>
            <ul className="space-y-4 text-white/80">
              <li className="flex gap-3">
                <Mail className="w-5 h-5 text-[#f7a11a] flex-shrink-0 mt-0.5" />
                <a href={`mailto:${company.email}`} className="hover:text-[#f7a11a] break-all">{company.email}</a>
              </li>
              <li className="flex gap-3"><Phone className="w-5 h-5 text-[#f7a11a] flex-shrink-0 mt-0.5" /><div><div>{company.phone}</div><div>{company.phone2}</div></div></li>
              <li className="flex gap-3"><MapPin className="w-5 h-5 text-[#f7a11a] flex-shrink-0 mt-0.5" /><span>{company.address}</span></li>
            </ul>
            <div className="mt-6">
              <div className="text-xs uppercase tracking-widest text-white/50 mb-2">{t('footer.globalMarkets')}</div>
              <div className="flex flex-wrap gap-1.5">
                {regions.map((r) => (<span key={r} className="text-xs px-2 py-1 bg-white/5 border border-white/10">{r}</span>))}
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50">
          <div>© {new Date().getFullYear()} Udaan Worldwide Export. {t('footer.rights')}</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#f7a11a]">Privacy Policy</a>
            <a href="#" className="hover:text-[#f7a11a]">Terms</a>
            <a href="#" className="hover:text-[#f7a11a]">Certifications</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
